export default {
  SET_HISTORIES(state, histories) {
    state.histories = histories;
  },
  ADD_HISTORIES(state, histories) {
    state.histories.list = state.histories.list.concat(histories.list);
    state.histories.count = histories.count;
    state.histories.target = histories.target;
    state.histories.totalPoint = histories.totalPoint;
  },
  RESET_STATE(state) {
    Object.assign(state, initialState());
  },
};

export const initialState = () => ({
  histories: { list: [], count: 0, target: {}, totalPoint: 0 },
});
